﻿import React, { useState } from 'react';

import { GMetrixButton } from 'components/GMetrixButton/GMetrixButton';
import { FormattedMessage, useIntl } from 'react-intl';

import 'components/GroupCode/group-code.scss';

import { useNotification } from 'app/notifications';
import { InputGroup } from 'react-bootstrap';

interface GroupCodeProps {
	className?: string;
	code: string | undefined;
}

export function GroupCode({ className, code }: GroupCodeProps) {

    const [copiedTheCode, setCopiedTheCode] = useState(false);
    const { formatMessage } = useIntl();
    const { createToast } = useNotification();
    const handleCopyClick = () => {

        if (code) {

            navigator.clipboard.writeText(code);
            setCopiedTheCode(true);
            createToast(formatMessage({ id: 'code_was_copied_to_clipboard.3ca3c48b', defaultMessage: 'Code was copied to clipboard' }), 'success');

            setTimeout(() => {

                setCopiedTheCode(false);

            }, 5000);

        }

    };

    return (
        <>

            <div className={`group-code-wrapper ${className ? className : ''}`}>
                <InputGroup>
                    <InputGroup.Text className="group-code-wrapper__code" style={{ paddingBottom: '8px' }}>
                        {code !== undefined && code.length > 0 ? code : <FormattedMessage defaultMessage="No Code Available" id="no_code_available.54ee1b2e" />}
                    </InputGroup.Text>
                    <GMetrixButton
                        disabled={copiedTheCode || code === undefined || code.length === 0}
                        onClick={handleCopyClick}
                        variant={'outline-primary'}
                    >

                        <i className="fa-light fa-copy fa-md text-primary me-2"></i>
                        <FormattedMessage defaultMessage="Copy" id="copy.fa37e351" />
                    </GMetrixButton>
                </InputGroup>
            </div>
        </>
    );

}
